/* eslint-disable array-callback-return */
import React, { useState, useEffect, useRef } from "react";
import { observer } from "mobx-react";
import "./DialerChannelSelector.scss";

const DialerChannelSelector = observer(props => {
  const { selectedChannel, onChannelChange, calling = false, disabled = false, showIndiaChannel = false } = props;
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const channelOptions = [
    {
      value: "default",
      label: "Channel 1 (default)",
      icon: "phone"
    },
    {
      value: "telnyx",
      label: "Channel 2",
      icon: "phone_in_talk"
    },
    ...(showIndiaChannel ? [{
      value: "india",
      label: "India",
      icon: "language"
    }] : [])
  ];

  const currentChannel = channelOptions.find(
    opt => opt.value === selectedChannel
  ) || channelOptions[0];

  const handleChannelSelect = channel => {
    if (!calling && !disabled) {
      onChannelChange(channel);
      setShowDropdown(false);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdown]);

  return (
    <div className={`dsChannelSection ${disabled ? "disabled" : ""}`}>
      <div className="dsWrapChannel" ref={dropdownRef}>
        <div
          onClick={() => {
            !calling && !disabled && setShowDropdown(!showDropdown);
          }}
          className="channelSection"
          style={{ cursor: disabled ? "not-allowed" : "pointer" }}
        >
          <div className="text">Channel: </div>
          <div className="channel">
            <i className="material-icons channelIcon">{currentChannel.icon}</i>
            <span className="channelText">{currentChannel.label}</span>
            {!calling && !disabled && (
              <i className="material-icons">keyboard_arrow_up</i>
            )}
          </div>
        </div>
        {showDropdown && (
          <>
            <div className="channelDropdown">
              <ul className="channelList">
                {channelOptions.map(option => {
                  const isSelected = selectedChannel === option.value;
                  return (
                    <li
                      key={option.value}
                      className={`channelOption ${isSelected ? "selected" : ""}`}
                      onClick={() => handleChannelSelect(option.value)}
                    >
                      <span className="radioButton">
                        <i className="material-icons">
                          {isSelected ? "radio_button_checked" : "radio_button_unchecked"}
                        </i>
                      </span>
                      <i className="material-icons channelIcon">{option.icon}</i>
                      <span className="channelLabel">{option.label}</span>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="channelDropdownOverlay" onClick={() => setShowDropdown(false)} />
          </>
        )}
      </div>
    </div>
  );
});

export default DialerChannelSelector;
export { DialerChannelSelector };
